import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);
export const submitPledge = (data) => axios.post(`${API}/pledge`, data).then((r) => r.data);
export const getPledgeCount = () => axios.get(`${API}/pledge/count`).then((r) => r.data.count);
